define('adminAssayTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('assays.details.tabTitle')
    }, {
      name: 'kitp',
      title: _.i18n('assays.kitp.tabTitle'),
      isDefault: true
    }, {
      name: 'anaassay',
      title: _.i18n('assays.anaassay.tabTitle')
    }
  ];
});
